import React from 'react';
import {Image, Title, Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle19 = () => (<div>

  <Title>The a brain-computer interface</Title>
  <Slideshow>

    <section>
      <Image
        source={require('./19_Bild_1.jpeg')}
        title='---'
        caption='Thought-powered computer games: a paraplegic participant during the “thought-controlled virtual race”.'
      />
    </section>
 
    <section>
      <Image
        source={require('./19_Bild_2_Unknown-1.jpg')}
        title='---'
        caption='Electrodes register the athletes’ brainwaves…'
      />
    </section>

    <section>
      <Image
        source={require('./19_Bild_3_Unknown-2.jpg')}
        title='---'
        caption='… which a computer then converts into signals that control characters in a game. To make these jump, run or
        slow down, various commands are required. The athletes use particular patterns of thought to generate these instructions.'
      />
    </section>

    <section>
      <Image
        source={require('./19_Bild_4_Unknown.jpg')}
        title='---'
        caption='A direct connection between the brain and a computer is called a brain-computer interface. Complex software is required to distinguish the various patterns. Fotos: ETHZ'
      />
    </section>

  </Slideshow>

  <Particle
  number={21}
  />

</div>);

export default Particle19;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle19/Particle19_EN.js
 **/